import React, { useCallback, useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import { SgActiveTestsContext } from 'saga-modules';
import CommonConstants from 'sg-common-constants';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './SgVoluntaryExcessCoverageContent.json5';

function SgVoluntaryExcessCoverageContent(props) {
    const {
        modelVM,
        updateData,
        addon,
        contentMessages,
        updateCoveragesAndCalculate
    } = props;
    const { activeMvtTests } = useContext(SgActiveTestsContext);
    const translator = useContext(TranslatorContext);
    const addonName = addon.patternCode.replace(/\s/g, '');

    const updateVolExcess = useCallback(() => {
        updateData(modelVM);
        if ((activeMvtTests.includes(CommonConstants.ACTIVE_MVT_TESTS.WOC_4177) || activeMvtTests.includes(CommonConstants.ACTIVE_MVT_TESTS.WOC_1169))
            && updateCoveragesAndCalculate) {
            updateCoveragesAndCalculate();
        }
    }, [activeMvtTests, updateData, updateCoveragesAndCalculate, modelVM]);

    return (
        <>
            <div className={`sg-add-on-icon-container ${addon.selected ? 'sg-addon-selected' : ''}`}>
                <div
                    className={`sg-add-on-icon-box sg-add-on-icon_${addonName}`}
                    aria-hidden="true"
                />
                <div className="sg-addon-icon-added">&nbsp;</div>
            </div>
            <div id={`coverageHeader_${addon.patternCode}`} className="sg-add-on-name">
                {translator(contentMessages.Name)}
            </div>
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
                onModelChange={updateVolExcess}
            />
            <div className="sg-add-on-description-box">
                {translator(contentMessages.Description)}
            </div>
        </>
    );
}

export default SgVoluntaryExcessCoverageContent;
